import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  listRemoteMCPServers,
  listRemoteMCPConnections,
  startRemoteMCPOAuth,
  disconnectRemoteMCP,
} from '@/api/remoteMCP'
import {
  setLoading,
  setError,
  setServers,
  setConnections,
  setConnectingServerId,
  removeConnection,
} from '@/redux/slices/remoteMCPSlice'

export const fetchRemoteMCPServersThunk = createAsyncThunk(
  'remoteMCP/fetchServers',
  async (_, { dispatch }) => {
    dispatch(setLoading(true))
    try {
      const servers = await listRemoteMCPServers()
      dispatch(setServers(servers))
      return servers
    } catch (err) {
      dispatch(setError('Failed to load research tool servers.'))
      throw err
    }
  }
)

export const fetchRemoteMCPConnectionsThunk = createAsyncThunk(
  'remoteMCP/fetchConnections',
  async (_, { dispatch }) => {
    try {
      const connections = await listRemoteMCPConnections()
      dispatch(setConnections(connections))
      return connections
    } catch (err) {
      dispatch(setError('Failed to load connections.'))
      throw err
    }
  }
)

export const startRemoteMCPOAuthThunk = createAsyncThunk(
  'remoteMCP/startOAuth',
  async (serverId: number, { dispatch }) => {
    dispatch(setConnectingServerId(serverId))
    try {
      const { auth_url } = await startRemoteMCPOAuth(serverId)
      const popup = window.open(
        auth_url,
        'scite_oauth',
        'width=600,height=700,scrollbars=yes,resizable=yes'
      )
      if (!popup) {
        window.location.href = auth_url
      }
      return auth_url
    } catch (err) {
      dispatch(setError('Failed to start OAuth connection. Please try again.'))
      throw err
    } finally {
      dispatch(setConnectingServerId(null))
    }
  }
)

export const disconnectRemoteMCPThunk = createAsyncThunk(
  'remoteMCP/disconnect',
  async (connId: number, { dispatch }) => {
    try {
      await disconnectRemoteMCP(connId)
      dispatch(removeConnection(connId))
    } catch (err) {
      dispatch(setError('Failed to disconnect. Please try again.'))
      throw err
    }
  }
)
